import React, { useEffect, useState } from 'react';
import {
FaUserClock,
FaUserCheck,
FaCalendarCheck,
FaClock,
FaRegCalendarMinus,
FaRunning,
FaSmile,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import api from '../../../../api';
import { useAuth } from '../../../Layouts/context/Authcontext';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';

const springEffect = {
type: 'spring',
stiffness: 120,
damping: 20,
};

const AttendanceSummaryCards = ({ filters }) => {
const [cardData, setCardData] = useState([]);
const [loading, setLoading] = useState(true);
const { accessToken } = useAuth();

useEffect(() => {
  const fetchAttendanceSummary = async () => {
    try {
      setLoading(true);
      const baseUrl = getRoundRobinBaseUrl();

      const filteredParams = {};
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          filteredParams[key] = filters[key];
        }
      });

      const response = await api.get(`${baseUrl}/superadminDashboard/getSuperAdminAttendanceReports`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: filteredParams,
      });

      if (response.data?.success && response.data?.data) {
        const data = response.data.data;
        setCardData([
          { title: 'Total FTE Worked', value: data.TotalFTEWorked, icon: <FaUserCheck /> },
          { title: 'Expected Biometric Hrs', value: data.ExpectedBiometricHrs, icon: <FaClock /> },
          { title: 'Actual Hrs', value: data.ActualHrs, icon: <FaUserClock /> },
          { title: 'Efficiency', value: data.Efficiency, icon: <FaSmile /> },
          { title: 'Days Worked', value: data.DaysWorked, icon: <FaCalendarCheck /> },
          { title: '# of Late', value: data.Late, icon: <FaRunning /> },
          { title: '# of Leaves', value: data.Leaves, icon: <FaRegCalendarMinus /> },
        ]);
      }
    } catch (error) {
      console.error('Error fetching attendance summary:', error);
      setCardData([]);
    } finally {
      setLoading(false);
    }
  };

  if (filters) {
    fetchAttendanceSummary();
  }
}, [accessToken, filters]);

if (loading) {
  return (
    <div className="flex justify-center items-center h-40">
      <div className="text-center text-gray-600 font-semibold">Loading Summary Cards...</div>
    </div>
  );
}

return (
  <div className="px-6 py-10 bg-[#F7F9FC]">
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 mb-10">
      {cardData.map((card, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ delay: i * 0.08, ...springEffect }}
          className="relative overflow-hidden bg-white bg-opacity-60 backdrop-blur-md border border-[#E2E8F0] rounded-3xl p-6 shadow-xl transition-all duration-300 group hover:scale-[1.025] hover:shadow-2xl"
        >
          <div className="absolute -top-10 -left-10 w-36 h-36 bg-[#EE1D23]/30 rounded-full blur-[80px] z-0 animate-pulse" />
          <div className="absolute -bottom-10 -right-10 w-36 h-36 bg-[#1A2B5C]/30 rounded-full blur-[80px] z-0 animate-pulse" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#1A2B5C15] to-[#EE1D2310] z-0 rounded-3xl" />
          <div className="relative z-10 flex flex-col items-center text-center space-y-2">
            <div className="text-4xl text-[#1A2B5C] group-hover:text-[#EE1D23] transition duration-300">{card.icon}</div>
            <p className="text-sm text-gray-600 font-semibold tracking-wide uppercase">{card.title}</p>
            <p className="text-3xl font-extrabold text-[#1A2B5C]">{card.value}</p>
            <div className="relative mt-2 h-1 w-16 rounded-full bg-gradient-to-r from-[#1A2B5C] to-[#EE1D23]">
              <div className="absolute inset-0 bg-white opacity-30 blur-md rounded-full animate-ping" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
);
};

export default AttendanceSummaryCards;
